// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  base_url: "https://services.dealshare.in/",
  keyClockSignInUrl:'https://keycloak.dealshare.in/realms/Dealshare/protocol/openid-connect/auth?client_id=prod-payment-panel&response_type=token',
  key_cloak_logout_url: 'https://keycloak.dealshare.in/realms/Dealshare/protocol/openid-connect/logout?client_id=prod-payment-panel'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
